import { module as m } from 'modujs';
import lottie from 'lottie-web';
import gsap from 'gsap';

export default class extends m {
    constructor(m) {
        super(m);

        // VAR
        this.animation = null;
        this.autoPlay = this.getData('autoplay') ? false : true;
    }

    /**
     * INIT
     */
    init() {
        if(this.getData('json')) {
            this.animation = lottie.loadAnimation({
                container: this.el,
                renderer: 'svg',
                loop: true,
                autoplay: this.autoPlay,
                path: this.getData('json'),
                name: this.el.dataset.moduleLottie
            });
        }
    }

    /**
     * CHANGE URL
     */
    changePath(i__url) {
        if(this.animation) {
            this.animation.pause();
            gsap.killTweensOf(this.el);

            const _tl = gsap.timeline();
            _tl.to(this.el, {
                duration: 0.6,
                autoAlpha: 0,
                yPercent: -10,
                rotate: 0.1,
                ease: 'power4.in'
            });
            _tl.call(() => {
                this.animation.destroy();
                this.animation = lottie.loadAnimation({
                    container: this.el,
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    path: i__url
                });
                gsap.set(this.el, {
                    autoAlpha: 0,
                    yPercent: 10,
                });
            }, null, 0.6)
            _tl.to(this.el, {
                duration: 0.6,
                autoAlpha: 1,
                yPercent: 0,
                rotate: 0.1,
                ease: 'power4.out'
            });
        }
    }

    /**
     * PLAY
     */
    play() {
        if(this.animation)
            this.animation.play();
    }

    /**
     * PAUSE
     */
    pause() {
        if(this.animation)
            this.animation.pause();
    }
}